import { PlanExplanation } from '@/module/payment';
export const PricingSection1 = () => {
  return <section className="bg-[linear-gradient(180deg,#FFF_0%,#F0F2F6_30%,#E9EAF2_50.28%,#F0F2F6_70%,#FFF_100%)] px-md py-2xl mobile-lg:px-lg tablet-sm:py-3xl tablet-lg:px-2xl" data-sentry-component="PricingSection1" data-sentry-source-file="PricingSection1.tsx">
      <PlanExplanation data-sentry-element="PlanExplanation" data-sentry-source-file="PricingSection1.tsx" />
    </section>;
};